import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsListItemUnread = function (props) {
    var isDefault = props.isDefault, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-unread", { ref: ref, "is-default": [true, false].includes(isDefault) ? (isDefault ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelContentDocumentsListItemUnread;
